<div class="nav-menu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 mt-4">
        <img class="profile-img " src={{user.picture}} alt="photo" />
      </div>
      <div class="col-sm-12 mt-2 name">
        {{user.name}}
      </div>
    </div>
  </div>
  <hr />

  <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/dashboard" routerLinkActive="active">
    <div class="menu-item">
      <div class="icon mr-2" aria-label="dashboard" [inlineSVG]="'assets/ico/homepage.svg'"></div>
      <div class="title">{{'sideMenu.homepage' | translate}}</div>
    </div>
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </a>

  <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/organization-chart" routerLinkActive="active">
    <div class="menu-item">
      <div class="icon mr-2" aria-label="reporting" [inlineSVG]="'assets/ico/organization-chart.svg'"></div>
      <div class="title">{{'sideMenu.organizationChart' | translate}}</div>
    </div>
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </a>

  <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/reports" routerLinkActive="active">
    <div class="menu-item">
      <div class="icon mr-2" aria-label="reporting" [inlineSVG]="'assets/ico/file-chart-line-regular.svg'"></div>
      <div class="title">{{'sideMenu.reporting' | translate}}</div>
    </div>
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </a>

  <div class="position-fixed administration" *checkPermission="{ type: 'CONTEXT'}">
    <hr>
    <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/administration" routerLinkActive="active">
      <div class="menu-item">
        <div class="icon mr-2" aria-label="reporting" [inlineSVG]="'assets/ico/cogs.svg'"></div>
        <div class="title">{{'sideMenu.administration' | translate}}</div>
      </div>
      <span></span><span></span><span></span><span></span><span></span><span></span>
    </a>
  </div>

</div>